<template>
  <b-container>
    <b-row>
      <slot />
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
@import '../../assets/style/vars';
@import '../../assets/style/utils';

@media (max-width: map-get($grid-breakpoints, lg)) {
}
</style>
